import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default class PersonalisationController extends React.Component {

    changeValue(property, value) {
        let newValues = this.props.customizedProperties;
        newValues[property] = value;
        if (value === null || value === undefined || value === '') {
            delete newValues[property];
        }

        this.props.onChange(newValues);
    }

    render() {

        if (!this.props.product.isPersonalisable) {
            return null;
        }

        const PersonalisationFormView = ComponentRegistry.get(this.props.view);

        return <PersonalisationFormView {...this.props}
                                        {...this.state}
                                        properties={ this.props.product.personalisableProperties }
                                        values={ this.props.customizedProperties }
                                        onValueChange={ this.changeValue.bind(this) }
        />
    }
}

PersonalisationController.propTypes = {
    url: PropTypes.string.isRequired,
    view: PropTypes.string.isRequired,
};
PersonalisationController.defaultProps = {
    view: "ProductPurchaseViewsPersonalisationFormView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Controllers/PersonalisationController.jsx